import * as React from 'react';
import { BulletsWrapper, ProjectContent, ProjectTitle, ProjectWrapper } from '../ProjectOverviewStyles';
import { generateBullets } from '../helpers/generateBullets';

export type Props = {
	project: any;
};

export const ProjectLayout = (props: Props) => {
	const render = () => {
		const returnValue = (
			<ProjectWrapper>
				<ProjectTitle>{props.project.text}</ProjectTitle>
				<ProjectContent>
					{/*<ToolsLayout tools={props.project.tools} />*/}
					<BulletsWrapper>{generateBullets(props.project.bullets)}</BulletsWrapper>
				</ProjectContent>
			</ProjectWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
